import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import ArrowButton from 'components/Buttons/ArrowButton';
import { AppContext } from 'context';
import { colors } from 'theme';
import BackButton from 'components/Buttons/BackButton';
import UpdatePasswordForm from './UpdatePasswordForm';

const useStyles = makeStyles({
  button: {
    margin: '2em 2em 2em 0',
  },
  userEmail: {
    color: colors.grey500,
    textTransform: 'none',
  },
  noMargin: {
    margin: '0',
  },
});

type TypeOfContentToDisplay = 'menu' | 'updateMail' | 'updatePassword' | 'updatePersonalInformation';

const Parameters: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'userProfile.parameters' });
  const [contentToDisplay, setContentToDisplay] = useState<TypeOfContentToDisplay>('menu');
  const context = useContext(AppContext);
  const user = context.user;

  const handleClickMainButton = (type: TypeOfContentToDisplay) => {
    setContentToDisplay(type);
  };

  const onSuccessUpdatePassword = () => {
    setContentToDisplay('menu');
  };

  return (
    <>
      {['updateMail', 'updatePassword', 'updatePersonalInformation'].includes(contentToDisplay) && (
        <BackButton
          onClick={() => {
            handleClickMainButton('menu');
          }}
        />
      )}
      {'menu' === contentToDisplay && (
        <>
          <ArrowButton
            onClick={() => {
              handleClickMainButton('updateMail');
            }}
            disabled
            aditionalClass={classes.button}
          >
            <p className={classes.noMargin}>
              {t('menu.updateMail')} - <span className={classes.userEmail}>{user ? user.email : ''}</span>
            </p>
          </ArrowButton>
          <ArrowButton
            onClick={() => {
              handleClickMainButton('updatePassword');
            }}
            aditionalClass={classes.button}
          >
            {t('menu.updatePassword')}
          </ArrowButton>
          <ArrowButton
            onClick={() => {
              handleClickMainButton('updatePersonalInformation');
            }}
            disabled
            aditionalClass={classes.button}
          >
            {t('menu.updatePersonalInformation')}
          </ArrowButton>
        </>
      )}
      {'updatePassword' === contentToDisplay && <UpdatePasswordForm onSuccess={onSuccessUpdatePassword} />}
    </>
  );
};

export default Parameters;
